import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { StyledError } from '../../../../theme/components/StyledError'
import { useCancelActiviteitForEntity } from '../../hooks/useCancelActiviteitForEntity'
import type { Activiteit } from '../../types/Activiteit'

interface Props {
  activiteit: Activiteit
  onClose: () => void
}

export const CancelActiviteitDialog = ({ activiteit, onClose }: Props) => {
  const { _id, type, entity } = activiteit
  const [comment, setComment] = useState('')
  const { mutate: cancelActiviteitForEntity, error } =
    useCancelActiviteitForEntity()

  const handleClickJa = () => {
    cancelActiviteitForEntity(
      {
        entity,
        activiteitInfo: {
          _id,
          text: comment,
        },
      },
      { onSuccess: () => onClose() },
    )
  }

  return (
    <>
      <DialogTitle>{`Annuleren ${type}`}</DialogTitle>
      <DialogContent>
        <StyledError error={error} />
        <Typography>{`Wilt u deze ${type} annuleren? `}</Typography>
        <TextField
          id="standard-textarea"
          fullWidth
          label={`Eventuele extra opmerking (${comment.length}/500)`}
          placeholder="Opmerking"
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          sx={{ mt: 1 }}
          rows={5}
          multiline
          slotProps={{ htmlInput: { maxLength: 500 } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Nee
        </Button>
        <Button onClick={handleClickJa} color="primary">
          Ja
        </Button>
      </DialogActions>
    </>
  )
}
